import {makeStyles} from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
  amountCurrency: {
    fontSize: 16,
    fontWeight: 300,
    padding: '0 3px',
    [theme.breakpoints.down('xs')]: {
      fontSize: 12,
    },
  },
  amountValue: {
    fontSize: 25,
    fontWeight: 300,
    [theme.breakpoints.down('xs')]: {
      fontSize: 18,
    },
  },
  amountFraction: {
    fontSize: 16,
    fontWeight: 300,
    [theme.breakpoints.down('xs')]: {
      fontSize: 12,
    },
  },
}))
